import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

export const SettlementView = angular
  .module('acme.view.application.settlement', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.settlement.controllers',
    'acme.common.directive.transactionDisplay',
    'acme.view.application.settlement.detail',
  ])

  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const settlement = {
      name: 'application.settlement',
      url: '/settlement',
      abstract: true,
      views: {
        'subview-main': {
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/settlement/settlement.tpl.html',
        },
      },
      data: {
        pageTitle: 'Settlement',
        roles: ['admin'],
      },
    };

    const settlementList = {
      name: 'application.settlement.list',
      url: '',
      views: {
        'subview-main': {
          controller: 'SettlementController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/settlement/settlementList.tpl.html',
        },
      },
      data: {
        pageTitle: 'Settlement',
      },
    };

    $stateProvider.state(settlement).state(settlementList);
  }).name;
